import { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  Typography,
} from "@mui/material";
import MaterialBox from "../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialSelect from "../../../components/MasterSelect";
import MaterialInput from "../../../components/MaterialInput";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import MaterialButton from "../../../components/MaterialButton";
import { useLoading } from "../../../context/loading";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";
import Swal from "sweetalert2";
import FilePreviewGrid from "./Filegrid";

import { ApolloClient, InMemoryCache } from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';
import { gql } from '@apollo/client';

const UpdateCourseMaterial = () => {

      const uploadLink = createUploadLink({ uri: BASEURL });
  const client = new ApolloClient({
    link: uploadLink,
    cache: new InMemoryCache(),
  });
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const courseid = searchParams.get("id"); // "JOB8767"
  const { circleLoading, setCirleLoading } = useLoading();
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [Allprojects, setAllprojects] = useState([
 
  ]);

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    modulename: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });
  const [filename, setfilename] = useState("");
  const [coursedetails, setCoursedetails] = useState({
    course: "",
    courseStatus: "unchecked",
    modulename: "",
    modulenameStatus: "unchecked",

    file: "",
    fileStatus: "unchecked",
  });

  console.log(coursedetails, "taskkkdett");




  useEffect(()=>{

fetchcourses()
  },[])

  useEffect(()=>{
    fetchcoarsematerial()
  },[courseid])

  const fetchcourses = async ()=>{
    const query =`
    
    query GetAllCourses {
  allCourses {
    id
    title
    status
    enrolmentStartDate
    enrolmentEndDate
  }
}
    
    `
    try{
     const res = await axios.post(BASEURL,{
        query

     })

     console.log(res.data.data.allCourses,"ALLCOURSES");

     const allcourses =res.data.data.allCourses
     setAllprojects(allcourses.map((course)=>({
        value:course?.id,
        label:course?.title
     })))
     
    }
    catch(err){
        console.log(err,"error");
        
    }
  }

  const fetchcoarsematerial = async ()=>{
    const query =`
    
query CourseMaterials($courseId: ID!) {
  courseMaterials(courseId: $courseId) {
    id
    moduleName
    file
    materialType
    course {
      id
      title
    }
    uploadedAt
  }
}
    
    `
    try{
     const res = await axios.post(BASEURL,{
        query,
        variables:{
        courseId:courseid
        }

     })

     console.log(res.data.data.courseMaterials,"courseMaterials");

     const allcourses = res?.data?.data?.courseMaterials
   setCoursedetails(()=>({
    ...coursedetails,
    file:allcourses
   }))

    //  const allcourses =res.data.data.allCourses
    //  setAllprojects(allcourses.map((course)=>({
    //     value:course?.id,
    //     label:course?.title
    //  })))
     
    }
    catch(err){
        console.log(err,"error");
        
    }
  }


  const handlecoursedetails = (feild, value) => {
    const updatedcoursedetails = { ...coursedetails };
    switch (feild) {
      case "course":
        if (value) {
          updatedcoursedetails.courseStatus = "success";
        }

        break;

      case "modulename":
        if (value.length > 4) {
          updatedcoursedetails.modulenameStatus = "success";
        } else {
          updatedcoursedetails.modulenameStatus = "error";
        }

        break;

      case "file":
        //             const file = value.target.files[0];
        //     console.log("filefile:", file.name);
        //     setfilename(file.name);
        //    updatedcoursedetails[feild] = file

        const files = Array.from(value.target.files); // Convert FileList to array
        console.log(
          "Selected files:",
          files.map((f) => f.name)
        );

        setfilename(files.map((f) => f.name + ",")); // Optional: if you want to show names

        updatedcoursedetails[feild] = files; // Save the array of files

        updatedcoursedetails.fileStatus = "success";
    }
    if (feild != "file") {
      updatedcoursedetails[feild] = value;
    }

    setCoursedetails(updatedcoursedetails);
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      coursedetails.courseStatus === "success" &&
      //   coursedetails.departmentStatus === "success" &&
      coursedetails.modulenameStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const onAddmaterial = async () => {
    setCirleLoading(true);
    const query = gql`mutation CreateCourseMaterial(
  $course_id: ID!,
  $module_name: String!,

  $file: Upload
) {
  createCourseMaterial(
    courseId: $course_id,
    moduleName: $module_name,
    
    file: $file
  ) {
    material {
      id
      moduleName
     
      file
    }
  }
}


`;

    const update = gql`
mutation UpdateMaterial(
  $id: ID!
  $module_name: String
  $file: Upload
) {
  updateCourseMaterial(
    id: $id
    moduleName: $module_name
    file: $file
  ) {
    material {
      id
      moduleName
      materialType
      file
    }
  }
}

`;
    let variables = null;
   console.log(variables);
   
    if (courseid) {
      variables = {
        id: courseid,
        module_name: coursedetails?.modulename,
        file: coursedetails?.file[0],
      };
    } else {
      variables = {
        course_id: coursedetails?.course?.value,
        module_name: coursedetails?.modulename,
        file: coursedetails?.file[0],
      };
    }

    try {
    //   const response = await axios({
    //     url: BASEURL,
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     data: JSON.stringify({
    //       query: courseid ? update : query,
    //       variables: variables,
    //     }),
    //   });

       const response = await client.mutate({
        mutation:courseid ? update: query,
        variables: variables,
      });

      if (!courseid) {

        console.log(response.data?.
createCourseMaterial
,"ciddd");
        
        let result = response.data.createCourseMaterial;
        if (result !== null) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "CourseMaterial Added Successfully",
            showConfirmButton: false,
            timer: 2500,
          });

          navigate("/recruitment/manually-added-candidate");
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Can't able to Add Candidate",
            showConfirmButton: false,
            timer: 2500,
          });
        }

        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(false);
      } else {
        let result = response.data.data.updateCandidate;
        if (result !== null) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Candidate Updated Successfully",
            showConfirmButton: false,
            timer: 2500,
          });

          navigate("/recruitment/manually-added-candidate");
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Can't able to Update Candidate",
            showConfirmButton: false,
            timer: 2500,
          });
        }

        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(false);
      }

      // console.log(
      //   "responsedata:",
      //   response.data.data.addleaveApproval?.leaveApproval
      // );
    } catch (error) {
      console.error("responseError:", error.response);
      setCirleLoading(false);
      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message: error.message,
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const handleAddmaterial = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: courseid
        ? "Are you sure you want to update your details?"
        : "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onAddmaterial();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          modulename={confirmationDialog.modulename}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}

      <Card>
        <CardHeader
          modulename={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
              padding={1}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={60}
              ></Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={1}>
              {/* course */}

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Courses
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="reason"
                  //   placeholder="Auto generated"

                  options={Allprojects}
                  value={coursedetails.course}
                  onChange={(e) => handlecoursedetails("course", e)}
                  success={coursedetails?.courseStatus == "success"}
                  error={coursedetails?.courseStatus == "error"}
                />
              </Grid>

              {/* task  modulename */}
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Module Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="modulename"
                  value={coursedetails.modulename}
                  onChange={(e) =>
                    handlecoursedetails("modulename", e.target.value)
                  }
                  error={
                    coursedetails.modulenameStatus === "error" ? true : false
                  }
                  success={
                    coursedetails.modulenameStatus === "success" ? true : false
                  }
                  disabled={togglePage.view === true ? true : false}
                />
              </Grid>

              <Grid
                //   mt={Finalresult[0]?.halfDayAllowed == false ? -8 : 0}
                size={{ xs: 5, sm: 4 }}
              >
                <MaterialBox lineHeight={0} display="inline-block" mb={1}>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Upload the Document <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <Box
                  component="label"
                  htmlFor="upload-file"
                  sx={{
                    border: "2px dashed #90caf9",
                    borderRadius: "12px",
                    padding: "21px 43px",
                    width: "100%",
                    minHeight: "100px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    backgroundColor: "#f5faff",
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: "#e3f2fd",
                    },
                  }}
                >
                  <CloudUploadIcon sx={{ fontSize: 50, color: "#2196f3" }} />
                  <Typography sx={{ mt: 1, color: "#2196f3", fontWeight: 500 }}>
                    Browse file to upload
                  </Typography>
                  <input
                    hidden
                    multiple
                    id="upload-file"
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={(e) => handlecoursedetails("file", e)}
                  />
                </Box>

                {coursedetails?.fileStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please upload a valid document (PDF, JPG, PNG).
                    </FormHelperText>
                  </FormControl>
                )}

                <FormHelperText>{filename}</FormHelperText>
              </Grid>

              {/* <Grid size={{ xs: 12, md: 12, lg: 12 }} container spacing={1}>
                {coursedetails?.file.length>0 &&coursedetails?.file?.map((file, index) => {
                  const fileURL = URL.createObjectURL(file);
                  const isImage = file.type.startsWith("image/");
                  const isPDF = file.type === "application/pdf";

                  return <Grid size={{ xs: 4, md: 4, lg: 4 }}>

                    {isImage && (
          <img
            src={fileURL}
            alt={file.name}
      
          />
        )}

        {isPDF && (
          <iframe
            src={fileURL}
            title={file.name}
         
          />
        )}


                  </Grid>;
                })}
              </Grid> */}

             { coursedetails.file.length>0 &&<FilePreviewGrid files={coursedetails.file} update={courseid?true:false}/>}
            </Grid>
          </MaterialBox>
        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          <>
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              // onClick={handleCancel}
            >
              Cancel
            </MaterialButton>
            <MaterialButton
              sx={{ m: 2, marginLeft: "4px" }}
              variant="gradient"
              color="dark"
              disabled={!checkAllFields()}
              onClick={handleAddmaterial}
            >
             { courseid?"Update": "Submit"}
            </MaterialButton>
          </>

          {/* {display && (
            <>
              <MaterialButton
                variant="gradient"
                color="dark"
                onClick={handleCancel}
              >
                Cancel
              </MaterialButton>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={LeaveEditRequest}
              >
                Update
              </MaterialButton>
            </>
          )} */}
        </MaterialBox>
      </Card>
    </DashboardLayout>
  );
};
export default UpdateCourseMaterial;
